export const CORE_EVENTS = {
  ERROR_401: "CORE_EVENTS.ERROR_401",
  ERROR_403: "CORE_EVENTS.ERROR_403",
  FORCE_UPDATE: "CORE_EVENTS.ERROR_426",
  ON_LOGOUT: "CORE_EVENTS.ON_LOGOUT",
  ON_LOGIN: "CORE_EVENTS.ON_LOGIN",
};
